import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  compact,
  get,
  orderBy,
} from 'lodash';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';

import {
  injectIntl,
  PrintableTable,
} from 'components';

class WarehouseListPrint extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
  };

  static propTypes = {
    deliveryDate: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    info: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),

    formatMessage: PropTypes.func.isRequired,
    printHeaderChecked: PropTypes.arrayOf(PropTypes.bool).isRequired,
    checkUpdated: PropTypes.func.isRequired,
  };

  static defaultProps = {
    info: [],
  };

  getListData = () => {
    const { currentUser } = this.context;
    const { info } = this.props;
    const dataList = info.map(({ data, packrow, order, quantity }) => ({
      buyerCompanyCode: get(order, 'contact.buyerCompanyCode'),
      sellerCompanyCode: get(order, 'contact.sellerCompanyCode'),
      buyerBusinessName: get(order, 'buyer.account.profile.companyName'),
      sellerBusinessName: get(data, 'seller.companyName') || get(order, 'contact.sellerProfile.companyName') || get(currentUser, 'account.profile.companyName'),
      description: get(data, 'description') ? get(data, 'description').trim() : '',
      itemName: `${get(data, 'productData.name')}, ${get(data, 'productData.subname')}`,
      itemUom: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
      itemQty: quantity || 0,
      price: (packrow.price || 0),
      cost: '$' + (packrow.cost || 0).toFixed(2),
      totalPrice:  '$' + ((((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2) * (quantity || 0)).toFixed(2),
      totalCost:  '$' + ((packrow.cost || 0) * (quantity || 0)).toFixed(2),
      discounted:  '$' + (((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2),
      total: quantity * (
        ((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2) || 0,
    }));

    const dataListNoZeroItems = dataList.filter(item => item.itemQty > 0);

    return orderBy(dataListNoZeroItems, ['description', 'itemName'], ['asc', 'asc']);
  }

  updateCheck = (isChecked, index) => {
    const { checkUpdated } = this.props;
    checkUpdated(isChecked, index);
  }

  render() {
    const {
      isDistributor,
      isFarmer,
    } = this.context;
    const {
      deliveryDate,
      formatMessage,
      loading,
      printHeaderChecked,
    } = this.props;
    const listData = this.getListData();
    const info = [];
    let currentDescription = '';
    for (let i = 0; i < listData.length; i++) {
      if (currentDescription === '' && i === 0) {
        currentDescription = listData[i].description;
      }
      if (currentDescription !== listData[i].description) {
        currentDescription = listData[i].description;
        info.push({ itemName: '' });
      }
      info.push(listData[i]);
    }
    const fields = compact([
      // {
      //   label: formatMessage('Code'),
      //   name: 'sellerCompanyCode',
      // },
      {
        label: formatMessage('Description'),
        name: 'description',
      },
      {
        label: formatMessage('Vendor'),
        name: 'sellerBusinessName',
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'itemName',
      },
      {
        label: formatMessage('Qty'),
        name: 'itemQty',
      },
      {
        label: formatMessage('Pack-Out'),
        name: 'itemUom',
      },
      {
        label: formatMessage('Customer'),
        name: 'buyerBusinessName',
      },
      {
        label: formatMessage('Customer Code'),
        name: 'buyerCompanyCode',
      },
      {
        label: formatMessage('Price'),
        name: 'discounted',
      },
      {
        label: formatMessage('Cost'),
        name: 'cost',
      },
      {
        label: formatMessage('Total Price'),
        name: 'totalPrice',
      },
      {
        label: formatMessage('Total Cost'),
        name: 'totalCost',
      },
    ]);
    const warehouseListHeader = `${formatMessage(`${isDistributor ? 'Vendor Warehouse Lists' : 'Purchase orders'} for`)} ${moment(deliveryDate).format('LLLL')}`;
    return (
      <div>
        {
          loading && (
            <div className="print-progress">
              <CircularProgress />
            </div>
          )
        }
        {!isFarmer ?
          (
            <div>
              <div className="packlist-header">{warehouseListHeader}</div>
              <div className="checked-list">
                {
                  fields.map((field, index) => (
                    <span key={index}>
                      <Checkbox
                        checked={printHeaderChecked[index]}
                        onChange={(e, isInputChecked) => this.updateCheck(isInputChecked, index)}
                        color="primary"
                      />
                      {field.label}
                    </span>
                  ))
                }
              </div>
              <PrintableTable
                checkedArray={printHeaderChecked}
                data={info}
                fields={fields}
                isWarehousePrint
              />
            </div>
          ) : ''
        }
      </div>
    );
  }
}

const wrappedWarehouseListPrint = injectIntl(WarehouseListPrint);
wrappedWarehouseListPrint.displayName = 'WarehouseListPrint';

export default wrappedWarehouseListPrint;
